<template>
    <div>
        <form action="" @submit.prevent="login">
            <h2>Test Login</h2>
            <input v-model="form.email" type="text" />
            <input v-model="form.password" type="password" />
            <button type="submit">Enviar</button>
        </form>
    </div>
</template>

<script>

    export default {
        
        data() {
            return {
                form: {
                    brand: 3,
                    email: 'omarproteger@gmail.com',
                    password: '123456789'
                }
            }
        },
        methods: {
            login(){
                this.$store.dispatch('autenticacion/loginToken', this.form)
            },

            error_login_gtm(){
                let gtm = useGtm();
          
                gtm.trackEvent({
                  'event': 'ev_error_form',
                  'category' : 'error',                          // Static data
                  'action': 'Error de autenticación',            // Dynamic data -> Action
                  'error_description': 'El correo no es válido.' // Dynamic Data -> Label
                })
            }
            
        },
    }
</script>

<style lang="scss" scoped>

</style>